import axios from "axios";


async function getImagesByQuery(query, page) {
    const { data } = await axios("https://pixabay.com/api/", {
        params: {
            key: "55695379-7a0fca570ad88a67ebcd7aaee",
            q: query,
            image_type: "photo",
            orientation: "horizontal",
            safesearch: true,
            per_page: 15,
            page,
        }
    })
    return data;
}



export { getImagesByQuery };